import { useTranslation } from 'react-i18next'

import { HTML_LINK_TARGET } from '../../../../../constants/html'
import { URL_ALIASES } from '../../../../../constants/route'
import { useUserData } from '../../../../../hooks'
import { isManagerUser } from '../../../../../utils/user'
import Button from '../../../../Button'
import { Link } from '../../../../Link'

import {
  QA_NAME_ADD_POST_BUTTON,
  QA_NAME_ADD_REQUEST_BUTTON,
  QA_NAME_HIDE_MESSAGE_BUTTON,
} from './NewsboardWelcomePostFooter.constants'
import { hidePost } from './NewsboardWelcomePostFooter.utils'

import * as styles from './NewsboardWelcomePostFooter.module.css'

import PlusIcon from '../../../../../icons/plus.svg'

function NewsboardWelcomePostFooter({ onHideWelcomePost }) {
  const { t } = useTranslation()

  const user = useUserData()

  const isManager = isManagerUser(user)

  function handleClickNewPost() {}

  function handleClickHidePost() {
    hidePost()

    onHideWelcomePost?.()
  }

  return (
    <div className={styles.container}>
      <Link
        rel='noreferrer'
        target={HTML_LINK_TARGET.blank}
        to={URL_ALIASES.requests}
      >
        <Button.Contained
          beforeIconProps={{ Icon: PlusIcon }}
          qaName={QA_NAME_ADD_REQUEST_BUTTON}
          text={t('Newsboard.AddNewRequestActionKey')}
        />
      </Link>
      {isManager ? (
        <Button.Outlined
          beforeIconProps={{ Icon: PlusIcon }}
          qaName={QA_NAME_ADD_POST_BUTTON}
          text={t('Newsboard.AddNewPostActionKey')}
          onClick={handleClickNewPost}
        />
      ) : null}
      <Button.Outlined
        qaName={QA_NAME_HIDE_MESSAGE_BUTTON}
        text={t('Newsboard.HideMessageActionKey')}
        onClick={handleClickHidePost}
      />
    </div>
  )
}

export default NewsboardWelcomePostFooter
